import {
  get,
  post,
  _delete
} from '../axios'

class VisitReport {
  async getApproveReportDetail(param) {
    const res = await get('/VisitReport/GetApproveVisitReportDetail', param)
    return res
  }
  async getInvalidReportDetail(param) {
    const res = await get('/VisitReport/GetInvalidReportDetail', param)
    return res
  }
  async delWaitApproveReport(param) {
    const res = await _delete('/VisitReport/DelWaitApproveReport', param)
    return res
  }
  async addApprovedReport(data, param) {
    const res = await post('/VisitReport/AddApprovedVisitReport', data, param)
    return res
  }
  async getLimit(param) {
    const res = await get('/VisitReport/GetLimit', param)
    return res
  }
  async addNewReport(data, param) {
    const res = await post('/VisitReport/AddNewReport', data, param)
    return res
  }
}
export default new VisitReport()